module.exports = __webpack_public_path__ + "media/recipes/151-5a953701.png";